import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Law() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (


    <>
      <Helmet>
        <title>Legal case management software - Taskflier</title>
      </Helmet>
        <div class="block-style-thirtySix bg-white lg-container pt-110 " id="feature">
          <div class="container">
            <div class="row">
              <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
                <div class="pl-lg-5">
                  <div class="title-style-fourteen">
                    <h6><span class="upper-title custom-name">Law</span></h6>
                    <h1>Lawyer Case Management Software</h1>
                  </div>
                  <div class="tag-line">Simplify your case management process with this powerful software for legal services and case management.</div>
                  <div class="tag-line">TaskFLier Case Management software is designed for law firms. Makes handling legal issues easier Investigation of various cases Document preparation and communication with customers All of this in one place. Reduce your paperwork On schedule and organize your team at the same time. With keeping clients up-to-date, this is the "best solution" for a more efficient and effective law firm. This helps your company grow and keep everything on track.</div>
                  <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">Request Demo <i class="bi bi-arrow-right pl-2"></i></Link>



                </div>
              </div>
              <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
                <div class="illustration-holder d-inline-block md-mt-60">
                  <img src="/main/images/compliant.png" alt="" class="w-100" />
                  <img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one" />
                  <img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two" />
                  <img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fancy-feature-thirtyOne pt-120 pb-160 md-pt-80 md-pb-100 bg-blue">
          <div class="container">
            <div class="row">
              <div class="col-lg-8 m-auto">
                <div class="title-style-four text-center pb-50 md-pb-20">
                  <h2>Pressures in the legal profession</h2>
                </div>
              </div>
            </div>
            <div class="row fixedbox">
              <div class="col-md-4 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-flex px-3">
                  <div class="text">
                    <h4>Case overload
                    </h4>
                    <p>Handling multiple cases at the same time can quickly become overwhelming to lawyers. With a deadline new customer information and huge amounts of data to manage It's easy to ignore important information. This results in errors, stress, and decreased productivi</p>

                  </div>
                </div>
              </div>
              <div class="col-md-4 aos-init" data-aos="fade-up" data-aos-delay="100">
                <div class="block-style-thirtyTwo d-flex px-3">
                  <div class="text">
                    <h4>Time management</h4>
                    <p>

                      Lawyers spend valuable time on administrative work. This leaves little time for billable work. Aligning these two responsibilities can affect productivity and customer focus. TaskFlier's automation tools help streamline routine tasks. This allows lawyers to devote more time to their clients.
                    </p>

                  </div>
                </div>
              </div>
              <div class="col-md-4 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-flex px-3">
                  <div class="text">
                    <h4>Communication area  </h4>
                    <p>

                      Poor communication with clients or team members can lead to misunderstandings, delays, and missed deadlines. This ultimately harms customer relationships. TaskFlier's integrated communication tools provide real-time updates and easy messaging. Help everyone stay informed and connected.

                    </p>

                  </div>
                </div>
              </div>
              <div class="col-md-6 aos-init" data-aos="fade-up" data-aos-delay="100">
                <div class="block-style-thirtyTwo d-flex px-3">
                  <div class="text">
                    <h4>Document Storage
                    </h4>
                    <p>An attorney is preparing for a critical case but can’t locate crucial documents scattered throughout emails, computing device folders, and paper documents. As time limits approach, the time lost looking increases the strain and dangers of missing critical records. TaskFlier’s steady garage answer organizes all files in one location with brief retrieval and model management, retaining the whole lot accessible and protected.</p>

                  </div>
                </div>
              </div>
              <div class="col-md-6 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-flex px-3">
                  <div class="text">
                    <h4>Compliance and Reporting</h4>
                    <p>Legal specialists face strict regulatory requirements, and staying compliant often entails time-consuming documentation and reporting. Without a reliable gadget, important closing dates or reporting information may be neglected. TaskFlier automates compliance-associated responsibilities, simplifying reporting and supporting lawyers to adhere to all prison requirements comfortably.</p>

                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
        <div class="fancy-feature-twentyNine lg-container pt-120  bg-white" id="p-tour">
          <div class="container">
            <div class="row">
              <div class="col-lg-8 m-auto">
                <div class="title-style-four text-center pb-50 md-pb-20">
                  <h3>Highly customizable, state-of-the-art software for legal case and matter management</h3>
                </div>
              </div>
            </div>
            <div class="block-style-thirty bottom-border pb-80 mb-170 md-pb-40 md-mb-90">

              <div class="row">
                <div class="col-xl-5 col-lg-6">
                  <div class="text-block md-pb-60">
                    <div class="feature">PRE-made template</div>
                    <div class="title-style-nine mb-45">
                      <h2>Centralize Your Documents</h2>
                    </div>
                    <p class="pb-30">TaskFlier software is designed for law firms. Makes handling legal issues easier Investigation of various cases Document preparation and communication with customers All of this in one place. Reduce your paperwork On schedule and organize your team at the same time. With keeping clients up-to-date, this is the "best solution" for a more efficient and effective law firm. This helps your company grow and keep everything on track.
                    </p>

                  </div>
                </div>
                <div class="col-xl-7 col-lg-6">
                  <img src="/images/assets/screen_35.png" alt="" />
                </div>
              </div>
            </div>
            <div class="block-style-thirty">
              <div class="row">
                <div class="col-xl-5 col-lg-6 order-lg-last">
                  <div class="text-block md-pb-60">
                    <div class="feature">PRE-made template</div>
                    <div class="title-style-nine mb-45">
                      <h2>Real-time collaboration tools </h2>
                    </div>
                    <p class="pb-30">Improve teamwork and communication with tools that help team members and customers work together seamlessly. Share updates, files, and messages instantly. So that everyone receives information and is consistent. This feature promotes productivity by providing immediate feedback. Helps reduce delays in decision-making.
                    </p>

                  </div>
                </div>
                <div class="col-xl-7 col-lg-6 order-lg-first">
                  <img src="/images/assets/screen_36.png" alt="" />
                </div>
              </div>
            </div>

            <div class="mt-80 pb-100 md-pb-80 bottom-border">
              <div class="row justify-content-between">
                <div class=" col-md-4 aos-init aos-animate" data-aos="fade-up">
                  <div class="block-style-twentyEight text-center mt-40">
                    <div class="icon d-flex justify-content-center align-items-end"><img src="/images/icon/160.svg" alt="" /></div>
                    <h4>Smart reporting and analytics</h4>
                    <p className='font-16'>Gain powerful insights through detailed reports and analytics. It helps you make informed decisions. Follow the progress of the case Track team performance and analyze financial data with custom reports that highlight key metrics. This feature provides a clear overview. This makes it easy to optimize operations and improve results</p>
                  </div>
                </div>
                <div class=" col-md-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                  <div class="block-style-twentyEight text-center mt-40">
                    <div class="icon d-flex justify-content-center align-items-end"><img src="/images/icon/161.svg" alt="" /></div>
                    <h4>Automatic Process</h4>
                    <p className='font-16'>Save time and reduce errors by automating repetitive tasks like creating forms. Reminder and data entry with process automation You can focus on productivity. Maintain accuracy while reducing workload. Automated processes help improve operations. Increase overall efficiency and effectiveness.</p>
                  </div>
                </div>
                <div class=" col-md-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                  <div class="block-style-twentyEight text-center mt-40">
                    <div class="icon d-flex justify-content-center align-items-end"><img src="/images/icon/162.svg" alt="" /></div>
                    <h4 className=''>Law enforcement and security built-in</h4>
                    <p className='font-16'>Protect sensitive data with advanced security measures that guarantee data integrity and privacy. Integrated compliance tools help you maintain compliance, reduce risk, and build customer trust. With strong encryption and access controls your data is safe and compliant.</p>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>

        <div class="fancy-feature-ten pt-100 bg-white" id="feature">
          <div class="bg-wrapper">
            <div class="container">
              <div class="row justify-content-between align-items-center">
                <div class="col-md-6 aos-init aos-animate" data-aos="fade-right" data-aos-duration="1200">
                  <div class="title-style-six">
                    <h3>More than case management—it's a complete digitization solution for legal practices.</h3>
                  </div>
                </div>

              </div>

              <div class="row justify-content-center mt-35 md-mt-20">
                <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-duration="1200">
                  <div class="block-style-fifteen mt-40">
                    <div class="icon d-flex align-items-center justify-content-center" ><img src="/images/icon/68.svg" alt="" /></div>
                    <h3>Personalize</h3>
                    <p className='font-16'>TaskFlier case management software allows you to completely personalize your workflow. Customize case management, reports, and documents to meet your organization's unique needs. With flexible settings and customizable templates, TaskFlier fits your practice. It helps you work more efficiently and keep everything on track</p>
                    <a href="#" class="mt-30"><img src="/images/icon/69.svg" alt="" /></a>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <div class="block-style-fifteen mt-40">
                    <div class="icon d-flex align-items-center justify-content-center" ><img src="/images/icon/67.svg" alt="" /></div>
                    <h3>Get mobile-readye</h3>
                    <p className='font-16'> TaskFlier's case management software is fully mobile-ready. It allows you to access case information, documents, and customer communications from any device. Stay connected and productive anywhere, anytime with seamless mobile that ensures you stay connected with updates or important information, no matter where you are.r</p>
                    <a href="#" class="mt-30"><img src="/images/icon/69.svg" alt="" /></a>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <div class="block-style-fifteen mt-40">
                    <div class="icon d-flex align-items-center justify-content-center" ><img src="/images/icon/70.svg" alt="" /></div>
                    <h3>Adaptable Billing</h3>
                    <p className='font-16'>TaskFlier's adaptive billing features allow you to customize your invoicing and payment policies based on each customer's needs. Track time, create detailed billing reports, and track time. And manage payments with precision and clarity This flexible approach makes the fundraising process easier. Increase customer satisfaction and improve billing for your legal practice.</p>
                    <a href="#" class="mt-30"><img src="/images/icon/69.svg" alt="" /></a>
                  </div>
                </div>
              </div>
            </div>
            <img src="/images/shape/137.svg" alt="" class="shapes shape-one" />
          </div>
        </div>

    </>
  )
}

export default Law
